// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useState } from 'react';
import { createAxios } from 'ts/createAxios';
import {
  Switch,
  Route,
  Redirect,
  useHistory,
  RouteProps,
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { pushHistory, resetHistory } from './redux/slices/historySlice';
import {
  selectIsSignin,
  setIsSignin,
  setIsCheckingSignin,
  resetPath,
} from './redux/slices/signinSlice';
import {
  setUser,
  resetUser,
  selectUser,
  UserState,
} from './redux/slices/userSlice';
import Login from 'pages/Login';
import UnCollects from 'pages/UnCollects';
import EmissionNew from 'pages/EmissionNew';
import Recycle from 'pages/Recycle';
import Traces from 'pages/Traces';
import TraceDetail from 'pages/TraceDetail';
import WeightNotices from 'pages/WeightNotices';
import AdminDownloads from 'pages/AdminDownloads';
import Histories from 'pages/Histories';
import RouteSettings from 'pages/RouteSettings';
import ScaleLogin from 'pages/ScaleLogin';
import ScaleSelectOperator from 'pages/ScaleSelectOperator';
import ScaleSelectType from 'pages/ScaleSelectType';
import ScaleEmission from 'pages/ScaleEmission';
import PoolDashboard from 'pages/PoolDashboard';

import {
  CompressionSiteType,
  OperatorType,
  ProcessingMode,
  RoleType,
  TenantAuthen,
} from './util/Enums';
import AdminSiteDetail from 'pages/AdminSiteDetail';
import AdminCustomizeItemsDetail from 'pages/AdminCustomizeItemsDetail';
import EmissionChild from 'pages/EmissionChild';
import AdminSiteListManagement from 'pages/AdminSiteListManagement/AdminSiteListManagement';
import AdminOperatorItems from 'pages/AdminOperatorItems';
import AdminOperatorListManagement from 'pages/AdminOperatorListManagement/AdminOperatorListManagement';
import SelectTenant from 'pages/SelectTenant';
import AdminAreaFloorManagement from 'pages/AdminSectionFloorManagement';
import TareWeightSubtraction from 'pages/TareWeightSubtractionManagement';
import AdminBrandOwnerManagement from 'pages/AdminBrandOwnerManagement';
import AdminEmissionResourceHistory from 'pages/AdminEmissionResourceHistory/AdminEmissionResourceHistory';
import AdminEmissionResourceManagement from 'pages/AdminEmissionResourceManagement';
import AdminUserListManagement from 'pages/AdminUserListManagement/AdminUserListManagement';
import AdminInvoiceManagement from 'pages/AdminInvoiceManagement/AdminInvoiceManagement';
import Dashboard from 'pages/Dashboard';
import AdminRecyleChainDesignListManagement from 'pages/AdminRecycleChainDesignListManagement/AdminRecyleChainDesignListManagement';
import AdminRecycleChainDesignAdd from 'pages/AdminRecycleChainDesignAdd';
import Page404 from 'pages/P404';
import AdminRecycleChainDesignEdit from 'pages/AdminRecycleChainDesignEdit';
import AdminConfirmInvoice from 'pages/AdminConfirmInvoice';
import AdminSiteBarcodeListManagement from 'pages/AdminSiteBarcodeListManagement/AdminSiteBarcodeListManagement';
import ScanICCard from 'pages/ScanICCard';
import ImportCSV from 'pages/ImportCSV';
import { LanguageValue, NETWORK_ERROR_MESSAGE } from 'util/ConstantValues';
import { resetSiteInfo } from 'redux/slices/siteInfoSlice';
import AdminBrandOwnerManagementDetail from 'pages/AdminBrandOwnerManagementDetail';
import ShippingRegistrationDetail from 'pages/ShippingRegistrationDetail';
import RecycleProductRegistration from 'pages/RecycleProductRegistration';
import ProductRegistration from 'pages/ProductRegistration';
import PurchaseDashboard from 'pages/PurchaseDashboard';
import Traceability from 'components/organisms/Traceability';
import PurchaseTraceDataDetail from 'pages/PurchaseTraceDataDetail';
import PurchaseHistories from 'pages/PurchaseHistories';
import PurchaseResourceSearch from 'components/organisms/PurchaseResourceSearch';
import PurchaseResourceManagement from 'components/organisms/PurchaseResourceManagement';
import { resetCategoryWasteUnit } from 'redux/slices/categoryWasteUnitSlice';
import { DbManager } from 'util/DbManager';
import CookiesAuth from 'util/CookiesAuth';
import ExternalScaleConnectionsHistory from 'pages/ExternalScaleConnectionsHistory';
import { useTranslation } from 'react-i18next';
import SiteManagement from 'pages/SiteManagement';
import ExportDataInvoice from 'pages/ExportDataInvoice';
import TenantDashboard from 'pages/TenantDashboard';
import TenantManagement from 'pages/TenantManagement';
import ResourceRegistrationHistories from 'pages/ResourceRegistrationHistories';
import UserSecurity from 'pages/UserSecurity';
import PurchaseUserSecurity from 'pages/PurchaseUserSecurity';
import { nonNull } from 'util/commons';
import ICCardScanHistory from 'pages/ICCardScanHistory';
import EmissionHistories from 'pages/EmissionHistories';
import CompressionHistories from 'pages/CompressionHistories';
import { resetHistoriesExport } from 'redux/slices/historiesCsvExportSlice';
import EmissionQRScan from 'pages/EmissionQRScan';
import BatchRegistration from 'pages/BatchRegistration';
import ProcessingMaster from 'pages/ProcessingMaster';
import PoolExportDataInvoice from 'pages/PoolExportDataInvoice';
import MyPage from 'pages/Mypage';
import CollectRoutes from 'pages/CollectRoutes';
import CollectConfirmDestinations from 'pages/CollectConfirmDestinations';
import RouteCollectQRScan from 'pages/CollectRouteQRScan';
import CollectSelectEmissionItems from 'pages/CollectSelectEmissionItems';
import CollectSiteSelection from 'pages/CollectSiteSelection';
import CollectSubstituteRegistration from 'pages/CollectSubstituteRegistration';
import { resetAllCollectingRouteState } from 'redux/slices/collectingRoute';
import TenantSort from 'pages/TenantSort';
import Shipment from 'pages/Shipment';
import CompressionAcceptances from 'pages/CompressionAcceptances';
import ProcessingRegistration from 'pages/ProcessingRegistration';
import AdminSiteStorageManagement from 'pages/AdminSiteStorageManagement';
import StorageLocationRegistration from 'pages/StorageLocationRegistration';
import SettlementAutoGeneration from 'pages/SettlementAutoGeneration';

export const Path = {
  login: '/login' /* 共通：ログイン */,
  staffs: '/staffs' /* 共通：スタッフ一覧 */,
  staffNew: '/staffs/new' /* 共通：スタッフ新規登録 */,
  staffEdit: '/staffs/:id' /* 共通：スタッフ編集 */,
  unCollects: '/un-collects' /** 排出事業者：未回収一覧 */,
  tareWeightSubtraction: '/tare-weight-subtraction' /* 風袋管理 */,
  importCSV: '/import-csv',
  batchRegistration: '/batch-registration' /* 一括登録 */,
  emissionNew: '/emissions/new' /* 排出事業者：排出登録 */,
  emissionNewDetail: '/emissions/new/:id',
  collectsRegist: '/collects/:id' /* 回収事業者：回収データ登録 */,
  collectsQRScanning: '/collects-qr-scanning' /* 回収事業者：QR回収する */,
  collectsSubstituteRegist:
    '/collects/substitute-regist' /* 回収事業者：代理登録 */,
  collectsSubstituteRegistWasteUnit:
    '/collects/substitute-regist/:siteId' /* 回収事業者：代理登録品目選択 */,
  collectsSubstituteRegistNew:
    '/collects/substitute-regist/:siteId/:id' /* 回収事業者：代理登録 */,
  shippingRegistrationDetail: '/shipping-registration/detail',
  recycle: '/recycle' /* 分別事業者：受け取り */,
  recycleProductRegistration: '/product-registration' /* 製品登録 */,
  separates: '/separates' /* 分別事業者：受け取り/分別登録 */,
  traceSearch: '/traces' /* 運営：トレースデータ検索 */,
  traceDetail: '/traces/:id' /* 運営：トレースデータ詳細 */,
  weightNotices: '/weight-notices' /* 運営：重量誤差アラート */,
  downloads: '/downloads' /* 運営：データダウンロード */,
  invoiceManagegement: '/invoice-management' /* 請求管理 */,
  adminSiteManagement: '/admin-site-management' /* 運営：品目設定 */,
  adminSiteManagementDetail:
    '/admin-site-management/:operatorId/:siteId' /* 運営：品目設定 */,
  adminSiteStoragesManagement:
    '/admin-storages-management/:operatorId/:siteId' /* 運営：一時保管場所管理 */,
  adminOperatorListManagement: '/admin-operator-management' /*事業者一覧画面*/,
  adminOperatorManagementDetail:
    '/admin-operator-management/:operatorId' /*排出拠点一覧画面*/,
  adminOperatorItems: '/admin-operator-management/:operatorId/items',
  // adminCustomizeItems: '/admin-customize',
  adminCustomizeItemsDetail:
    '/admin-site-management/:operatorId/:siteId/:categoryId' /* 運営：品目設定 */,
  adminSectionFloorManagement:
    '/admin-site-management/:operatorId/:siteId/section-floor/management',
  adminBrandOwnerManagement: '/admin-brand-owner-management' /*ブランド管理*/,
  adminBrandOwnerManagementDetail: '/admin-brand-owner-management/:id',
  adminEmissionResourceManagement: '/admin-data-resource-management', //資源一覧画面
  adminEmissionResourceHistory: '/admin-data-resource-history', //資源一覧画面
  adminRecycleChainDesignManagement: '/admin-recycle-chain-design-management', // リサイクルチェーンデザイン
  adminRecycleChainDesignAdd: '/admin-recycle-chain-design-add',
  adminRecycleChainDesignEdit: '/admin-recycle-chain-design-edit/:id',
  adminConfirmInvoice: '/admin-confirm-invoice', //請求内容確認
  scanICCard: '/scan-ic-card',
  emissionQRScanning: '/emission-qr-scanning',
  ICCardScanHistory: '/ic-card-scan-history' /* ICカードスキャン履歴 */,
  histories: '/histories' /* 共通：登録履歴 */,
  compressionHistories: '/compression-histories',
  emissionHistories: '/emisssion-histories',
  resourceRegistrationHistories: '/resource-registration-histories',
  scaleLogin: '/scale-login' /* 計量器：ログイン */,
  scaleSelectOperator: '/scales/select-operator' /* 計量器：事業者SELECT */,
  scaleSelectType: '/scales/select-type' /* 計量器：品目SELECT */,
  scaleEmission: '/scales/emission' /* 計量器：排出登録 */,
  selectTenant: '/select-tenant',
  tenantSort: '/tenant-sort',
  barcodes: '/barcodes' /* バーコード一覧 */,
  externalScaleConnectionsHistory: '/external-scale-connections-history',
  siteManagement: '/sites',
  exportDataInvoice: '/export-data-invoice',
  poolExportDataInvoice: '/pool-export-data-invoice',
  tenantManagement: '/tenants',
  siteUserManagement: '/site-user-management',

  // purchase
  purchaseResourceManagement: '/resource-management/:id',
  purchaseDashboard: '/purchase-dashboard/:recycleChainId',
  purchaseProductRegistration: '/purchase-product-registration',
  purchaseTraces: '/traceability',
  purchaseTraceDataDetail: '/traceability/:id',
  purchaseHistories: '/purchase-histories',
  purchaseResourceSearch: '/resource-search',
  purchaseUserSecurity: '/purchase-user-security',

  userManagement: '/user-management',
  // 404 Page
  pageNotFound: '/404',
  dashboard: '/dashboard',

  // Pool admin
  poolDashboard: '/pool-dashboard',
  poolUserSecurity: '/pool-user-security',

  tenantDashboard: '/tenant-dashboard',
  tenantDashboardDetail: '/tenant-dashboard/:tenantId',

  processingMaster: '/processing-master',

  myPage: '/my-page',
  settlementAutoGeneration: '/settlement-auto-generation',

  // route setting
  routeSettings: '/route-settings',
  routeList: '/routes',
  routeDetail: '/routes/:routeId',
  collectItemInSite: '/routes/:routeId/sites/:siteId/collect',
  substituteRegistration:
    '/routes/:routeId/sites/:siteId/substitute-registration',
  routeSiteSelection: '/routes/:routeId/sites',
  routeSiteQRScanning: '/routes/:routeId/sites/:siteId/qr',

  acceptances: '/acceptances',
  shipment: '/shipment-registration',
  processingRegistration: '/processing-registration',
  storageLocationRegistration: '/storage-location-registration',
};

export const OFFLINE_USAGE_SUPPORT_ROUTES = [
  Path.dashboard,
  Path.selectTenant,
  Path.emissionNew,
  Path.pageNotFound,
];

// operatorTypeごとにFirstPageをSwitchする
export const firstPage = (user: UserState) => {
  if (user.operatorType === OperatorType.Emissions) {
    if (localStorage.getItem('scale-login') === 'true') {
      return Path.scaleEmission;
    }

    if (user.role === RoleType.AdminTenant) {
      return Path.tenantDashboard;
    }

    if (user.role === RoleType.AdminOperator) {
      return Path.dashboard;
    }

    if (user.role === RoleType.AdminSite) {
      return Path.dashboard;
    }

    if (user.isShowTenants) {
      return Path.selectTenant;
    }

    return Path.emissionNew;
  }

  if (user.operatorType === OperatorType.Collects) {
    if (user.role === RoleType.UserNormal) {
      return Path.routeList;
    }

    return Path.routeSettings;
  }

  if (user.operatorType === OperatorType.Compressions) {
    if (user.role === RoleType.AdminSite) {
      return Path.acceptances;
    }

    return Path.siteUserManagement;
  }

  if (user.operatorType === OperatorType.Recycle) {
    return Path.recycle;
  }

  if (user.operatorType === OperatorType.Separates) {
    return Path.separates;
  }

  if (user.operatorType === OperatorType.Admin) {
    return Path.traceSearch;
  }

  if (user.operatorType === OperatorType.Purchase) {
    return Path.purchaseProductRegistration;
  }

  if (
    user.operatorType === OperatorType.Brand &&
    user.role === RoleType.BrandOwner
  ) {
    return Path.dashboard;
  }

  if (user.role === RoleType.AdminPool) {
    return Path.poolDashboard;
  }

  if (localStorage.getItem('scale-login') === 'true') {
    return Path.scaleLogin;
  }

  return Path.login;
};

// const SigninRequireRoot: React.FC<RouteProps> = (props) => {
//   const isSignIn = useSelector(selectIsSignin)
//   const referrer = useSelector(selectReferrer)
//   const user = useSelector(selectUser)

//   // Pathの直打はhistoryのstoreで判断
//   const isDirect = referrer.length === 0
//   // ログインの有無によって飛ばす先を変える
//   const redirectPath = isSignIn ? firstPage(user) : Path.login

//   if (isSignIn) {
//     return <Route {...props} />
//   }

//   return <Redirect to={redirectPath} />
// }

/**
 * 事業者権限別ルーティング
 * @param props
 * @returns
 */
type Permission = {
  roles?: RoleType[];
  operatorTypes?: OperatorType[];
  customCondition?: boolean;
};

interface OperatorRouteProps extends RouteProps {
  permissions: Permission[];
  adminOnly?: boolean;
  onUnmounted?: () => void;
}

interface ScaleLoginRouteProps extends RouteProps {
  operatorTypes: string[];
  adminOnly?: boolean;
}

function adminCheck(user: UserState, adminOnly: boolean) {
  return adminOnly ? user.isAdmin : true;
}

const OperatorRequireRoot: React.FC<OperatorRouteProps> = ({
  permissions,
  onUnmounted,
  ...props
}) => {
  const { i18n } = useTranslation();
  const isSignIn = useSelector(selectIsSignin);
  const user = useSelector(selectUser);
  // ログインの有無によって飛ばす先を変える

  useEffect(() => {
    if (user.role === RoleType.AdminRecotech) {
      i18n.changeLanguage(LanguageValue.Japanese);
    }
  }, [user.role]);

  useEffect(() => {
    return () => {
      onUnmounted?.();
    };
  }, [onUnmounted]);

  if (!isSignIn) {
    return <Redirect to={Path.login} />;
  }

  const redirectPath = firstPage(user);

  const isAdminSiteEmissions =
    user.operatorType === OperatorType.Emissions &&
    user.role === RoleType.AdminSite;

  const isUserNormalEmissions =
    user.operatorType === OperatorType.Emissions &&
    user.role === RoleType.UserNormal;

  if (
    props.path === Path.barcodes &&
    isAdminSiteEmissions &&
    user.originalTenantAuthen !== TenantAuthen.Barcode
  ) {
    return <Redirect to={Path.pageNotFound} />;
  }

  if (
    props.path === Path.scanICCard &&
    (isAdminSiteEmissions || isUserNormalEmissions) &&
    user.originalTenantAuthen !== TenantAuthen.ICCard
  ) {
    return <Redirect to={Path.pageNotFound} />;
  }

  const permissionGranted =
    !permissions.length ||
    permissions.some(({ roles, operatorTypes, customCondition }) => {
      if (roles && user.role && !roles.includes(nonNull(user.role))) {
        return false;
      }

      if (
        operatorTypes &&
        !operatorTypes.includes(user.operatorType as OperatorType)
      ) {
        return false;
      }

      if (customCondition != null && !customCondition) {
        return false;
      }

      return true;
    });
  if (!permissionGranted) {
    return <Redirect to={Path.pageNotFound} />;
  }

  if (permissionGranted && adminCheck(user, props.adminOnly ?? false)) {
    return <Route {...props} />;
  }

  return <Redirect to={permissionGranted ? redirectPath : '/'} />;
};

const ScaleLoginRoute: React.FC<ScaleLoginRouteProps> = (props) => {
  const isSignIn = useSelector(selectIsSignin);
  const user = useSelector(selectUser);

  if (localStorage.getItem('scale-login') != 'true') {
    const redirectPath = isSignIn ? firstPage(user) : Path.login;
    return <Redirect to={redirectPath} />;
  }

  if (
    isSignIn &&
    props.operatorTypes.includes(user.operatorType) &&
    adminCheck(user, props.adminOnly ?? false)
  ) {
    return <Route {...props} />;
  }

  return <Redirect to={Path.scaleLogin} />;
};

const SignoutRequireRoot: React.FC<RouteProps> = (props) => {
  const isSignIn = useSelector(selectIsSignin);
  const user = useSelector(selectUser);

  if (isSignIn) {
    return <Redirect to={firstPage(user)} />;
  } else {
    return <Route {...props} />;
  }
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ToppageRoot: React.FC<RouteProps> = (props) => {
  const isSignIn = useSelector(selectIsSignin);
  const user = useSelector(selectUser);

  if (isSignIn) {
    return <Redirect to={firstPage(user)} />;
  } else {
    return <Redirect to={Path.login} />;
  }
};

const Routes: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isCallingAPI, setIsCallingAPI] = useState(true);
  const user = useSelector(selectUser);

  useEffect(() => {
    const checkSignin = async () => {
      dispatch(setIsCheckingSignin(true));
      const auth = CookiesAuth.accessToken;

      if (auth) {
        if (user.userId == '') {
          try {
            const api = createAxios();
            const response = await api.get('/auth/my-account');
            // リロード対策のため、この時点でもユーザ情報の取得
            const payload: UserState = {
              // ユーザー情報取得APIからの情報格納
              ...response.data,
              isAdmin: response.data.role == 0,
            };

            DbManager.updateUserInfo(response.data);
            window.nativeUpdateUser(response.data);
            dispatch(setUser(payload));
          } catch (e: any) {
            let hasError = true;

            if (e?.message === NETWORK_ERROR_MESSAGE) {
              const cachedUserInfo = await DbManager.userInfo.toArray();

              if (cachedUserInfo.length) {
                dispatch(
                  setUser({
                    ...cachedUserInfo[0],
                    isAdmin: (cachedUserInfo[0].role as any) == 0,
                  })
                );

                hasError = false;
              }
            }

            if (hasError) {
              // handle logout if call my-account error
              CookiesAuth.logout();
              window.nativeUpdateUser(null);

              await DbManager.clearExceptWasteRegistrations();

              dispatch(setIsCheckingSignin(false));
              dispatch(setIsSignin(false));
              dispatch(resetSiteInfo());
              dispatch(resetCategoryWasteUnit());
              dispatch(resetUser());
              dispatch(resetHistory());
              dispatch(resetPath());
              dispatch(resetHistoriesExport());
              localStorage.removeItem('i18nextLng');

              window.location.reload();
            }
          }
        }
        dispatch(setIsSignin(true));
      } else {
        dispatch(setIsSignin(false));
        dispatch(resetUser);
      }

      dispatch(setIsCheckingSignin(false));

      setIsCallingAPI(false);
    };
    checkSignin();

    history.listen(() => {
      dispatch(pushHistory({ history: window.location.pathname }));
    });
  }, [dispatch, history]);

  const handleResetCollectingRouteState = useCallback(() => {
    dispatch(resetAllCollectingRouteState());
  }, [dispatch]);

  if (isCallingAPI) {
    return null;
  } else {
    return (
      <Switch>
        <ToppageRoot exact path={'/'} />
        <SignoutRequireRoot exact path={Path.login} component={Login} />
        <SignoutRequireRoot
          exact
          path={Path.scaleLogin}
          component={ScaleLogin}
        />
        <ScaleLoginRoute
          exact
          operatorTypes={[OperatorType.Emissions]}
          path={Path.scaleSelectOperator}
          component={ScaleSelectOperator}
        />
        <ScaleLoginRoute
          exact
          operatorTypes={[OperatorType.Emissions]}
          path={Path.scaleSelectType}
          component={ScaleSelectType}
        />
        <ScaleLoginRoute
          exact
          operatorTypes={[OperatorType.Emissions]}
          path={Path.scaleEmission}
          component={ScaleEmission}
        />
        {/** 排出事業者*/}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.unCollects}
          component={UnCollects}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
            },
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Recycle],
              customCondition: user.enableSubSite,
            },
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Compressions],
              customCondition:
                user.enableSubSite &&
                user.siteType !== CompressionSiteType.Storage,
            },
          ]}
          exact
          path={Path.emissionNew}
          component={EmissionNew}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
            },
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Recycle],
              customCondition: user.enableSubSite,
            },
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Compressions],
              customCondition:
                user.enableSubSite &&
                user.siteType !== CompressionSiteType.Storage,
            },
          ]}
          exact
          path={Path.emissionNewDetail}
          component={EmissionChild}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
            },
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Recycle],
              customCondition: user.enableSubSite,
            },
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Compressions],
              customCondition:
                user.enableSubSite &&
                user.siteType !== CompressionSiteType.Storage,
            },
          ]}
          exact
          path={Path.selectTenant}
          component={SelectTenant}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.tenantSort}
          component={TenantSort}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.tareWeightSubtraction}
          component={TareWeightSubtraction}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.importCSV}
          component={ImportCSV}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.batchRegistration}
          component={BatchRegistration}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.externalScaleConnectionsHistory}
          component={ExternalScaleConnectionsHistory}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.siteManagement}
          component={SiteManagement}
        />
        {/** 請求データ出力 */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.exportDataInvoice}
          component={ExportDataInvoice}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminPool],
            },
          ]}
          exact
          path={Path.poolExportDataInvoice}
          component={PoolExportDataInvoice}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.tenantManagement}
          component={TenantManagement}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [
                RoleType.AdminSite,
                RoleType.BrandOwner,
                RoleType.AdminOperator,
              ],
              operatorTypes: [
                OperatorType.Emissions,
                OperatorType.Brand,
                OperatorType.Collects,
                OperatorType.Compressions,
                OperatorType.Recycle,
              ],
            },
          ]}
          exact
          path={Path.siteUserManagement}
          component={UserSecurity}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminPool],
            },
          ]}
          exact
          path={Path.poolUserSecurity}
          component={UserSecurity}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator, RoleType.AdminSite],
              operatorTypes: [OperatorType.Collects],
            },
          ]}
          exact
          path={Path.routeSettings}
          component={RouteSettings}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator, RoleType.AdminSite],
              operatorTypes: [OperatorType.Collects],
            },
          ]}
          exact
          path={Path.settlementAutoGeneration}
          component={SettlementAutoGeneration}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [
                RoleType.AdminOperator,
                RoleType.AdminSite,
                RoleType.UserNormal,
              ],
              operatorTypes: [OperatorType.Collects],
            },
          ]}
          exact
          path={Path.routeList}
          component={CollectRoutes}
          onUnmounted={handleResetCollectingRouteState}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [
                RoleType.AdminOperator,
                RoleType.AdminSite,
                RoleType.UserNormal,
              ],
              operatorTypes: [OperatorType.Collects],
            },
          ]}
          exact
          path={Path.routeSiteQRScanning}
          component={RouteCollectQRScan}
          onUnmounted={handleResetCollectingRouteState}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [
                RoleType.UserNormal,
                RoleType.AdminOperator,
                RoleType.AdminSite,
              ],
              operatorTypes: [OperatorType.Collects],
            },
          ]}
          exact
          path={Path.routeDetail}
          component={CollectConfirmDestinations}
          onUnmounted={handleResetCollectingRouteState}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [
                RoleType.UserNormal,
                RoleType.AdminOperator,
                RoleType.AdminSite,
              ],
              operatorTypes: [OperatorType.Collects],
            },
          ]}
          exact
          path={Path.routeSiteSelection}
          component={CollectSiteSelection}
          onUnmounted={handleResetCollectingRouteState}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [
                RoleType.UserNormal,
                RoleType.AdminOperator,
                RoleType.AdminSite,
              ],
              operatorTypes: [OperatorType.Collects],
            },
          ]}
          exact
          path={Path.substituteRegistration}
          component={CollectSubstituteRegistration}
          onUnmounted={handleResetCollectingRouteState}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [
                RoleType.UserNormal,
                RoleType.AdminOperator,
                RoleType.AdminSite,
              ],
              operatorTypes: [OperatorType.Collects],
            },
          ]}
          exact
          path={Path.collectItemInSite}
          component={CollectSelectEmissionItems}
          onUnmounted={handleResetCollectingRouteState}
        />
        {/** 圧縮事業者*/}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Compressions],
              customCondition: user.siteType !== CompressionSiteType.Storage,
            },
          ]}
          exact
          path={Path.processingRegistration}
          component={ProcessingRegistration}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Compressions],
            },
          ]}
          exact
          path={Path.shippingRegistrationDetail}
          component={ShippingRegistrationDetail}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Compressions],
            },
          ]}
          exact
          path={Path.acceptances}
          component={CompressionAcceptances}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Compressions],
              customCondition: user.siteType === CompressionSiteType.Storage,
            },
          ]}
          exact
          path={Path.storageLocationRegistration}
          component={StorageLocationRegistration}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Compressions],
            },
          ]}
          exact
          path={Path.shipment}
          component={Shipment}
        />

        {/** リサイクル事業者*/}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Recycle],
            },
          ]}
          exact
          path={Path.recycle}
          component={Recycle}
        />
        {/** 製品登録*/}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Recycle],
            },
          ]}
          exact
          path={Path.recycleProductRegistration}
          component={RecycleProductRegistration}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Purchase],
            },
          ]}
          exact
          path={Path.purchaseDashboard}
          component={PurchaseDashboard}
        />
        {/** 運営事業者*/}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.traceSearch}
          component={Traces}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.userManagement}
          component={AdminUserListManagement}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminSiteManagementDetail}
          component={AdminSiteDetail}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminCustomizeItemsDetail}
          component={AdminCustomizeItemsDetail}
        />
        {/*事業者一覧画面*/}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminOperatorListManagement}
          component={AdminOperatorListManagement}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminSectionFloorManagement}
          component={AdminAreaFloorManagement}
        />
        {/*排出拠点一覧画面*/}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminOperatorManagementDetail}
          component={AdminSiteListManagement}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminOperatorItems}
          component={AdminOperatorItems}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.traceDetail}
          component={TraceDetail}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.weightNotices}
          component={WeightNotices}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.downloads}
          component={AdminDownloads}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.invoiceManagegement}
          component={AdminInvoiceManagement}
        />
        {/** ブランド管理 */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminBrandOwnerManagement}
          component={AdminBrandOwnerManagement}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminBrandOwnerManagementDetail}
          component={AdminBrandOwnerManagementDetail}
        />

        {/* Dashboard */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [
                RoleType.AdminOperator,
                RoleType.AdminSite,
                RoleType.BrandOwner,
              ],
              operatorTypes: [OperatorType.Emissions, OperatorType.Brand],
            },
          ]}
          exact
          path={Path.dashboard}
          component={Dashboard}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminPool],
            },
          ]}
          exact
          path={Path.poolDashboard}
          component={PoolDashboard}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminTenant],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.tenantDashboard}
          component={TenantDashboard}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.tenantDashboardDetail}
          component={TenantDashboard}
        />

        {/** データ編集 */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminEmissionResourceHistory}
          component={AdminEmissionResourceHistory}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminEmissionResourceManagement}
          component={AdminEmissionResourceManagement}
        />

        {/** リサイクルチェーンリスト*/}
        {/** 請求内容確認 */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminRecycleChainDesignManagement}
          component={AdminRecyleChainDesignListManagement}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminRecycleChainDesignAdd}
          component={AdminRecycleChainDesignAdd}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminRecycleChainDesignEdit}
          component={AdminRecycleChainDesignEdit}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminConfirmInvoice}
          component={AdminConfirmInvoice}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminRecotech],
              operatorTypes: [OperatorType.Admin],
            },
          ]}
          exact
          path={Path.adminSiteStoragesManagement}
          component={AdminSiteStorageManagement}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.tareWeightSubtraction}
          component={TareWeightSubtraction}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.barcodes}
          component={AdminSiteBarcodeListManagement}
        />
        {/** 全事業者 */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [
                RoleType.AdminOperator,
                RoleType.UserNormal,
                RoleType.AdminSite,
              ],
              operatorTypes: [
                OperatorType.Collects,
                OperatorType.Separates,
                OperatorType.Recycle,
              ],
            },
          ]}
          exact
          path={Path.histories}
          component={Histories}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Compressions],
            },
          ]}
          exact
          path={Path.compressionHistories}
          component={CompressionHistories}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [
                RoleType.AdminOperator,
                RoleType.AdminSite,
                RoleType.UserNormal,
                RoleType.AdminTenant,
              ],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.emissionHistories}
          component={EmissionHistories}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Recycle],
            },
          ]}
          exact
          path={Path.resourceRegistrationHistories}
          component={ResourceRegistrationHistories}
        />
        {/* カードのスキャン  */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.scanICCard}
          component={ScanICCard}
        />

        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
              customCondition: user.temporaryStorageEnabled,
            },
          ]}
          exact
          path={Path.emissionQRScanning}
          component={EmissionQRScan}
        />

        {/* ICカードスキャン履歴 */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminSite, RoleType.UserNormal],
              operatorTypes: [OperatorType.Emissions],
            },
          ]}
          exact
          path={Path.ICCardScanHistory}
          component={ICCardScanHistory}
        />

        {/* 加工マスタ  */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Recycle],
              customCondition: user.processingMode === ProcessingMode.Auto,
            },
            {
              roles: [RoleType.AdminSite],
              operatorTypes: [OperatorType.Compressions],
              customCondition:
                user.processingMode === ProcessingMode.Auto &&
                user.siteType !== CompressionSiteType.Storage,
            },
          ]}
          exact
          path={Path.processingMaster}
          component={ProcessingMaster}
        />

        {/* purchase */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Purchase],
            },
          ]}
          exact
          path={Path.purchaseResourceManagement}
          component={PurchaseResourceManagement}
        />

        {/** 製品登録*/}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Purchase],
            },
          ]}
          exact
          path={Path.purchaseProductRegistration}
          component={ProductRegistration}
        />
        {/** トレーサビリティ*/}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Purchase],
            },
          ]}
          exact
          path={Path.purchaseTraceDataDetail}
          component={PurchaseTraceDataDetail}
        />

        {/* purchaseTraces */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Purchase],
            },
          ]}
          exact
          path={Path.purchaseTraces}
          component={Traceability}
        />

        {/* 履歴 */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Purchase],
            },
          ]}
          exact
          path={Path.purchaseHistories}
          component={PurchaseHistories}
        />
        {/* purchaseResourceSearch */}
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Purchase],
            },
          ]}
          exact
          path={Path.purchaseResourceSearch}
          component={PurchaseResourceSearch}
        />
        <OperatorRequireRoot
          permissions={[
            {
              roles: [RoleType.AdminOperator],
              operatorTypes: [OperatorType.Purchase],
            },
          ]}
          exact
          path={Path.purchaseUserSecurity}
          component={PurchaseUserSecurity}
        />

        <OperatorRequireRoot
          permissions={[
            {
              operatorTypes: [OperatorType.Emissions],
              roles: [RoleType.AdminOperator, RoleType.AdminSite],
            },
            {
              operatorTypes: [OperatorType.Collects],
              roles: [
                RoleType.AdminOperator,
                RoleType.UserNormal,
                RoleType.AdminSite,
              ],
            },
            {
              operatorTypes: [OperatorType.Compressions, OperatorType.Recycle],
              roles: [RoleType.AdminOperator],
            },
            {
              roles: [RoleType.AdminPool],
            },
          ]}
          exact
          path={Path.myPage}
          component={MyPage}
        />

        {/* 404 */}
        <Route exact path={Path.pageNotFound} component={Page404} />
        <Route path="*">
          <Redirect to={'/404'} />
        </Route>
      </Switch>
    );
  }
};

export default Routes;
